import { PaginatedResponse } from "shared/types";

export interface LockboxProperty {
  id: number;
  name: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state_or_province?: string;
    postal_code?: string;
  };
}

export interface LockboxUnit {
  id: number;
  title: string;
}

export interface LockboxCreatedBy {
  id: number;
  name: string;
  email: string;
}

export interface Lockbox {
  id: number;
  name: string;
  code: string;
  property: LockboxProperty | null;
  unit: LockboxUnit | null;
  created_at: string;
  created_by: LockboxCreatedBy | null;
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc"
}

export interface GetLockboxesParams {
  page?: number;
  per_page?: number;
  search?: string;
  sort_by?: string;
  sort_order?: SortOrder;
  property_id?: number;
  unit_id?: number;
  available?: boolean;
}

export type GetLockboxesResponse = PaginatedResponse<Lockbox>;

export interface LockboxPayload {
  name: string;
  code: string;
  property_id: number;
  unit_id?: number | null;
}
